/**
* Project janux-vuejs-seed
* Created by hielo on 2018-05-10
*/

<template lang="pug">
	div
		// fieldset(v-for="(phone, index) in data.contactMethods.phones")
		fieldset
			.state-zip-row
				// .left-side
					.field-title(v-if="countryCode") Country Code
					.error-val.error-contact(v-if="countryCode === ''") Enter the country code
					.each-field-contact: b-form-input.all-fields(type="number", placeholder='Country Code', v-model="countryCode", :class="{errorInField: !countryCode}", @input="validate")
				.left-side
					// .field-title(v-if="areaCode") Area Code
					.field-title(:class="{errorContactLabel: !areaCode && isCheckout}") Area Code
						span(v-if="isRequired") &nbsp;*
					// .error-val.error-contact(v-if="areaCode === ''") Enter the area code
					.each-field-contact: b-form-input.all-fields(type="number", v-model="areaCode", @input="validate", :class="{errorInField: !areaCode && isCheckout}")
				.right-side
					// .field-title(v-if="data.phoneNumber().number") Phone Number
					.field-title(:class="{errorContactLabel: !data.phoneNumber().number && isCheckout}") Phone Number
						span(v-if="isRequired") &nbsp;*
					// .error-val.error-contact(v-if="!data.phoneNumber().number") Enter the phone number
					.each-field-contact: b-form-input.all-fields(v-model="data.phoneNumber().number", @input="validate", :class="{errorInField: !data.phoneNumber().number && isCheckout}")

</template>

<script>
import {PhoneNumber} from 'janux-people'
import _ from 'lodash'

export default {
	name: 'jnx-phone',
	props: ['sectionTitle', 'data', 'isValid', 'isCheckout', 'isRequired'],
	data () {
		return {
			phoneTypes: ['HOME', 'WORK', 'MOBILE', 'FAX', 'OTHER'],
			areaCode: '',
			countryCode: ''
		}
	},
	methods: {
		removePhone (index) {
			this.data.contactMethods.phones.splice(index, 1)
		},
		addNewPhone () {
			this.data.setContactMethod('work', new PhoneNumber())
		},
		validate () {
			// Temp solution to ensure areaCode and countryCode setter is working
			if (!_.isNil(this.areaCode)) {
				this.data.phoneNumber().areaCode = this.areaCode
			}

			if (!_.isNil(this.countryCode)) {
				this.data.phoneNumber().countryCode = this.countryCode
			}

			// console.log('this.data.phoneNumber().number', this.data.phoneNumber().number)
			this.isValid.phone = !!(this.data.phoneNumber().number)
			let iterate = true
			Object.keys(this.isValid).forEach(key => {
				if (key !== 'result') {
					if (!this.isValid[key] && iterate) {
						iterate = false
						this.isValid.result = false
					} else if (this.isValid[key] && iterate) {
						this.isValid.result = true
					}
				}
			})
		}
	},
	beforeMount () {
		// Temp solution to ensure areaCode and countryCode setter is working
		this.areaCode = this.data.phoneNumber().areaCode
		this.countryCode = this.data.phoneNumber().countryCode
		// TODO: Try to detect steps to produce this error
		// Commented line because exist a random browser console error that seems solve this
		this.validate()
	},
	computed: {
		componentTitle () {
			return this.$t(this.sectionTitle)
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/party/phone.vue